module.exports = __webpack_public_path__ + "static/media/icon_mg03.4ee4bc92.svg";